(function () {
  'use strict';
  angular.module('app').config(accountingBillingUrlConfig);
  accountingBillingUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

  function accountingBillingUrlConfig($routeProvider, $locationProvider) {
    $routeProvider.
      when('/accounting/customer-billing/:id', {
        templateUrl: '/templates/pages/accounting/customer-billing-details.html',
        controller: 'AccountingCustomerBillingDetailsController',
        controllerAs: 'vm',
        params: {
          parent: 'accounting-billing',
          subParent: 'customer-billing',
          htmlTitle: 'Customer Billing Details',
          pageTitle: 'Customer Billing Details'
        }
      }).
      when('/accounting/customer-billing/shipment-details/:shipmentId', {
        templateUrl: '/templates/pages/accounting/shipment-details.html',
        controller: 'AccountingShipmentDetailsController',
        controllerAs: 'vm',
        params: {
          parent: 'accounting-billing',
          subParent: 'customer-billing',
          htmlTitle: 'Invoiced Shipment Details',
          pageTitle: 'Invoiced Shipment Details',
          deepMenuParent: {
            itemText: 'Customer Billing Details',
            url: '/accounting/customer-billing/:id',
          }
        }
      }).
      when('/accounting/historical-billing/', {
        templateUrl: '/templates/pages/accounting/historical-billing.html',
        controller: 'AccountingHistoricalBillingController',
        controllerAs: 'vm',
        params: {
          parent: 'accounting-billing',
          htmlTitle: 'Historical Billing',
          pageTitle: 'Historical Billing'
        }
      }).
      when('/accounting/historical-billing/:id', {
        templateUrl: '/templates/pages/accounting/historical-billing-details.html',
        controller: 'AccountingHistoricalBillingDetailsController',
        controllerAs: 'vm',
        params: {
          parent: 'accounting-billing',
          subParent: 'historical-billing',
          htmlTitle: 'Historical Billing Details',
          pageTitle: 'Historical Billing Details'
        }
      }).
      when('/accounting/issue-credit-notes', {
        templateUrl: '/templates/pages/accounting/accounting-issued-credit-notes.html',
        controller: 'AccountingIssuedCreditNotesController',
        controllerAs: 'vm',
        params: {
          parent: 'accounting-billing',
          htmlTitle: 'Issued Credit/Debit Notes',
          pageTitle: 'Issued Credit/Debit Notes'
        }
      }).
      when('/accounting/customers-billing-settings', {
        templateUrl: '/templates/pages/accounting/accounting-customers-billing-settings.html',
        controller: 'AccountingCustomersBillingSettingsController',
        controllerAs: 'vm',
        params: {
          parent: 'accounting-billing',
          htmlTitle: 'Customer Billing Settings',
          pageTitle: 'Customer Billing Settings'
        }
      });
    $locationProvider.html5Mode({
      enabled: true,
      requireBase: false
    });
  }
})();



// WEBPACK FOOTER //
// ./js/urls/accounting-billing.js